<template>
  <div>
    <div class="sjbox" style="background-color: #67C23A;">
      <div class="box-icon"><i class="el-icon-user-solid"></i></div>
      <div class="box-sj">
        <p>{{jdnum}}</p>
        <p>今日建档</p>
      </div>
    </div>
    <div class="sjbox" style="background-color: #E6A23C;">
      <div class="box-icon"><i class="el-icon-s-claim"></i></div>
      <div class="box-sj">
        <p>{{ghnum}}</p>
        <p>今日挂号</p>
      </div>
    </div>
    <div class="sjbox" style="background-color: #F56C6C;">
      <div class="box-icon"><i class="el-icon-sell"></i></div>
      <div class="box-sj">
        <p>{{inmoney}}</p>
        <p>今日收费</p>
      </div>
    </div>
    <div class="sjbox" style="background-color: #909399;">
      <div class="box-icon"><i class="el-icon-sold-out"></i></div>
      <div class="box-sj">
        <p>{{outmoney}}</p>
        <p>今日退费</p>
      </div>
    </div>
    <!-- 统计图 -->
    <el-row :gutter="23">
      <el-col :span="23" class="text-c">
        <div class="st-gbox">
          <div class="cavasbox" ref="SUMEchart"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { indexshow } from '../../api/baseset'
  import Chart from 'echarts'
  export default {
    data() {
      return {
        jdnum: 0,
        ghnum: 0,
        inmoney: 0,
        outmoney: 0
      }
    },
    created() {
      this.getdata()
    },
    methods: {
      getdata() {
        indexshow().then(res => {
          if(res.code == 0){
            this.jdnum = res.data.jdnum
            this.ghnum = res.data.ghnum
            this.inmoney = res.data.inmoney
            this.outmoney = res.data.outmoney
            this.getSUM(res.data.months,res.data.ysrtj)
          }
        })
      },
      // 收入金额
      getSUM(months,ysrtj) {
        let sdata = {
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}月 : {c}"
          },
          legend: {
            data: [{
              name: '收入总金额',
              icon: 'rect'
            }],
            top: 1,
            left: 1,
            itemGap: 10,
            itemWidth: 12,
            itemHeight: 12,
            textStyle: {
              fontSize: 12,
              color: "#323232"
            }
          },
          grid: {
            left: 50,
            right: 10,
            top: 30,
            bottom: 30,
            borderWidth: 1
          },
          xAxis: {
            type: 'category',
            data: months,
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1
              }
            },
            axisLabel: {
              margin: 14,
              height: 70,
              interval: 0,
              textStyle: {
                fontSize: 10,
                color: "#999999"
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1
              }
            },
            axisLabel: {
              margin: 14,
              textStyle: {
                fontSize: 10,
                color: "#999999"
              }
            }
          },
          series: [{
            name: '收入总金额',
            //   type: 'bar',
            type: 'line',
            barGap: 0,
            data: ysrtj,
            barWidth: 10,
            itemStyle: {
              color: "#108ff9"
            }
          }]
        }
        this.chart = Chart.init(this.$refs.SUMEchart)
        this.chart.setOption(sdata)
      },
    }
  }
</script>

<style>
  .sjbox{width: 18%;margin-top: 10px;margin-left: 4%;background-color: white;height: 100px;float: left;padding: 10px;border-radius: 6px;
  box-shadow: 0 1px 1px rgb(0 0 0 / 5%);color: white;font-weight: bold;}
  .box-icon{font-size: 60px;width: 40%;height: 100px;line-height: 100px;float: left;}
  .box-sj{width: 60%;float: left;height: 100px;}

  .text-c {
    text-align: center;
  }
  .st-gbox {
    background-color: #fff;
    margin-top: 20px;
    border-radius: 5px;
    height: 30vh;
    box-sizing: border-box;
    padding: 10px;
  }
  .cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/base/index.vue